import { createSlice } from '@reduxjs/toolkit';
import SectionNavId from './SectionNavId';

export type TrailPageState = {
  activeSection: SectionNavId;
  isScrollingViaTabs?: boolean;
  isTrailMapOpen?: boolean;
  viewLimitReached: 'uninitialized' | boolean;
};

export const initialState: TrailPageState = {
  activeSection: 'overview',
  isScrollingViaTabs: false,
  isTrailMapOpen: false,
  viewLimitReached: 'uninitialized'
};

export const trailPageSlice = createSlice({
  name: 'trailPage',
  initialState,
  reducers: {
    setActiveSection: (state, action: { payload: SectionNavId }) => {
      state.activeSection = action.payload;
    },
    setIsScrollingViaTabs: (state, action: { payload: boolean }) => {
      state.isScrollingViaTabs = action.payload;
    },
    setIsTrailMapOpen: (state, action: { payload: boolean }) => {
      state.isTrailMapOpen = action.payload;
    },
    setViewLimitReached: (state, action: { payload: boolean }) => {
      state.viewLimitReached = action.payload;
    }
  }
});

export const { setActiveSection, setIsScrollingViaTabs, setIsTrailMapOpen, setViewLimitReached } = trailPageSlice.actions;
export default trailPageSlice.reducer;
